var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 6.54785H4C3.80109 6.54785 3.61032 6.62687 3.46967 6.76752C3.32902 6.90817 3.25 7.09894 3.25 7.29785V24.2979C3.25 24.762 3.43437 25.2071 3.76256 25.5353C4.09075 25.8635 4.53587 26.0479 5 26.0479H27C27.4641 26.0479 27.9092 25.8635 28.2374 25.5353C28.5656 25.2071 28.75 24.762 28.75 24.2979V7.29785C28.75 7.09894 28.671 6.90817 28.5303 6.76752C28.3897 6.62687 28.1989 6.54785 28 6.54785ZM16 17.2804L5.9275 8.04785H26.0725L16 17.2804ZM12.7087 16.2979L4.75 23.5929V9.00285L12.7087 16.2979ZM13.8188 17.3154L15.5 18.8504C15.6383 18.9768 15.8189 19.047 16.0063 19.047C16.1936 19.047 16.3742 18.9768 16.5125 18.8504L18.1875 17.3154L26.0725 24.5479H5.92875L13.8188 17.3154ZM19.2913 16.2979L27.25 9.00285V23.5929L19.2913 16.2979Z",
    fill: "#FFBA26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.bdd39fd170d846bf3c57da3be2969438.svg";
export { ForwardRef as ReactComponent };